import React from "react"
import { Link as PrismicLink } from "prismic-reactjs"

import { Element, Text } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import { PrismicFooterDataBodyNavColumnItemType } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  link: Maybe<PrismicFooterDataBodyNavColumnItemType>
}

type FooterLinkProps = OwnProps

const FooterLink: React.FC<FooterLinkProps> = ({
  link,
}): React.ReactElement | null => {
  if (!link?.link_url) return null

  const linkText = link.link_text
  const linkType = link.link_url?.link_type
  const linkUrl = link.link_url

  return (
    <Element as="li" mb={["10", "15"]}>
      {linkType === "Document" ? (
        <Link
          display="block"
          fontSize={["17", "17", "text.footerLink"]}
          lineHeight={["22px", "22px", "normal"]}
          py={["10px", "5px", "0"]}
          to={PrismicLink.url(linkUrl)}
          variant="footerLink"
        >
          {linkText}
        </Link>
      ) : (
        <Text
          as="a"
          display="block"
          fontSize={["17", "17", "text.footerLink"]}
          href={PrismicLink.url(linkUrl)}
          lineHeight={["22px", "22px", "normal"]}
          py={["10px", "5px", "0"]}
          textDecoration="none"
          variant="footerLink"
        >
          {linkText}
        </Text>
      )}
    </Element>
  )
}

export default FooterLink
